import { createGlobalStyle } from "styled-components";

const CuvamaUIGlobalStyles = createGlobalStyle`
  :root {
    /* Icons */
    --icon-default: #717680;
    --icon-hover: #414651;
    --icon-deactivated: #D5D7DA;
    --icon-light: #FFFFFF;

    /* Text */
    --text-primary: #181D27;
    --text-secondary: #414651;
    --text-tertiary: #535862;
    --text-light: #FFFFFF;

    /* Button: Primary */
    --button-primary: #7F56D9;
    --button-primary-hover: #6941C6;
    --button-primary-clicked: #53389E;
    --button-primary-default: transparent;

    /* Button: Stroke */
    --button-stroke-border: #D5D7DA;

    /* Button: Filled */
    --button-filled: #F5F5F5;
    --button-filled-hover: #E9E9E9;

    /* Button: Text */
    --button-text-hover: #F5F5F5;
    --button-text-clicked: #E9E9E9;

    /* Button: Focus */
    --button-focused-shadow: rgba(127, 86, 217, 0.24);

    /* Button: Ghost */
    --button-ghost-bg: rgba(255, 255, 255, 0.1);
    --button-ghost-bg-hover: rgba(255, 255, 255, 0.2);
    --button-ghost-bg-clicked: rgba(255, 255, 255, 0.3);
    --button-ghost-border: rgba(255, 255, 255, 0.3);
    --button-ghost-border-hover: rgba(255, 255, 255, 0.5);
    --button-ghost-border-clicked: rgba(255, 255, 255, 0.6);
    --button-ghost-focused-border: rgba(255, 255, 255, 0.5);
    --button-ghost-filled-hover: #F0F0F0;
    --button-ghost-text-hover: #FFFFFF;
    --button-ghost-link: #D6BBFB;
    --button-ghost-link-hover: #E9D7FE;
    --button-ghost-divider: rgba(255, 255, 255, 0.2);

    /* Links */
    --link-default: #7F56D9;
    --link-hover: #6941C6;

    /* Status */
    --primary: #7F56D9;
    --error: #D92D20;

    /* Typography */
    --font-family-body: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
      Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
    --font-weight-regular: 400;
    --font-weight-semi-bold: 600;
    --font-size-small: 14px;
    --font-size-body: 16px;
    --line-height-small: 20px;
    --line-height-body: 24px;

    /* Spacing */
    --gap-0: 4px;
    --gap-2: 8px;
    --gap-3: 12px;
    --gap-4: 16px;

    /* Border */
    --border-radius-medium: 6px;
  }
`;

export default CuvamaUIGlobalStyles;
